export enum MimeTypes {
  PNG = 'image/png',
  GIF = 'image/gif',
  JPEG = 'image/jpeg',
  PDF = 'application/pdf',
  HEIC = 'image/heic',
}
